import { render, staticRenderFns } from "./RejoinSessionModal.vue?vue&type=template&id=81c22b50&scoped=true&"
import script from "./RejoinSessionModal.vue?vue&type=script&lang=js&"
export * from "./RejoinSessionModal.vue?vue&type=script&lang=js&"
import style0 from "./RejoinSessionModal.vue?vue&type=style&index=0&id=81c22b50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c22b50",
  null
  
)

export default component.exports